<template>
  <el-dialog
    :title="$t('SmartLocker.RejectDialogTitle')"
    :visible="isDialogVisible"
    class="reject-apply-dialog"
    :show-close="true"
    @close="closeDialog"
    width="60%"
  >
    <div class="title">
      <span class="hint">* </span>
      <template v-if="postalData.length > 1">
        {{ $t('SmartLocker.RejectApplyForCount1') }}
        <span class="postal-info"> {{ postalData.length }} </span>
        {{ $t('SmartLocker.RejectApplyForCount2') }}
      </template>
      <template v-else-if="postalData.length === 1">
        {{ $t('SmartLocker.RejectApplyForPostal1') }}
        <span class="postal-info"> {{ `#${postalData[0].SerialNum} ${postalData[0].TabletNote} ${postalData[0].PostalName}` }} </span>
        {{ $t('SmartLocker.RejectApplyForPostal2') }}
      </template>
    </div>
    <div class="cancel-reason-type-select">
      <el-select v-model="cancelReasonTypeSelect">
        <el-option
          v-for="item in cancelReasonTypeOption"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        />
      </el-select>
    </div>
    <div v-if="cancelReasonTypeSelect === 1" class="cancel-reason-info">
      <el-input
        type="textarea"
        v-model="cancelReasonInfo"
        :rows="8"
        :placeholder="$t('SmartLocker.ReasonInfoPlaceholder')"
        maxlength="50"
        resize="none"
        show-word-limit
      >
      </el-input>
    </div>
    <div class="footer">
      <el-button
        round
        type="primary"
        @click="rejectApply"
      >
        {{ $t('SmartLocker.ConfirmReject') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { apiSmartLocker } from '@/api/SmartLocker.js'
export default {
  props: {
    postalData: Array
  },
  data () {
    return {
      isDialogVisible: false,
      cancelReasonTypeSelect: null,
      cancelReasonTypeOption: [],
      cancelReasonInfo: ''
    }
  },
  watch: {
    cancelReasonTypeSelect () {
      if (!this.cancelReasonTypeSelect || this.cancelReasonTypeSelect === 1) this.cancelReasonInfo = ''
      else {
        const cancelReason = this.cancelReasonTypeOption.find((item) => item.Id === this.cancelReasonTypeSelect)
        this.cancelReasonInfo = cancelReason.Name
      }
    }
  },
  async created () {
    await this.getCancelReasonTypeOption()
  },
  methods: {
    async getCancelReasonTypeOption () {
      try {
        const res = await apiSmartLocker.GetCancelReasonType()
        if (res?.data?.Data) this.cancelReasonTypeOption = res.data?.Data.CancelReasonTypeList || []
      } catch (e) {
        console.log(e)
      }
    },
    openDialog () {
      this.isDialogVisible = true
    },
    closeDialog () {
      this.isDialogVisible = false
      this.cancelReasonTypeSelect = null
      this.cancelReasonInfo = ''
    },
    rejectApply () {
      if (!this.cancelReasonTypeSelect || (this.cancelReasonTypeSelect === 1 && !this.cancelReasonInfo)) {
        this.$alert(this.$t('SmartLocker.NoReasonAlertBody'), this.$t('SmartLocker.NoReasonAlertTitle'), {
          confirmButtonText: this.$t('General.OK'),
          type: 'warning',
          callback: action => {}
        })
        return
      }
      this.$emit('confirmReject', this.cancelReasonTypeSelect, this.cancelReasonInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.reject-apply-dialog {
  ::v-deep .el-dialog {
    @include basicDialog;
    text-align: left;
    .title {
      margin-bottom: 16px;
      .hint {
        color: $dangerColor;
      }
      .postal-info {
        color: $mainColor;
        font-size: map-get($fontSize, small);
        font-weight: bold;
      }
    }
    .cancel-reason-type-select {
      margin-bottom: 24px;
    }
    .cancel-reason-info {
      margin-bottom: 32px;
    }
    .footer {
      text-align: center;
    }
  }
}
</style>
